const pageNameKey = "serviceUsersList";

export const serviceUsersListEn = {
  [pageNameKey]: {
    nameLabel: "Display Name",
    usernameLabel: "Username",
    rolesLabel: "Roles",
    statusLabel: "Status",
    expirationDateLabel: "Expiration Date",
    createdAtLabel: "Created At",
    updatedAtLabel: "Last Modified",
    statusTextActive: "Active",
    statusTextInactive: "Inactive",
    statusTextInitial: "Initial",
    noServiceUsersFoundMessage: "No service users could be found.",
    rolesDescriptionPopoverAltText: "Hover for roles description",
  },
};

export const serviceUsersListPtBr = {
  [pageNameKey]: {
    nameLabel: "Nome de exibição",
    usernameLabel: "Nome de usuário",
    rolesLabel: "Funções",
    statusLabel: "Status",
    expirationDateLabel: "Data de validade",
    createdAtLabel: "Criado em",
    updatedAtLabel: "Última modificação",
    statusTextActive: "Ativo",
    statusTextInactive: "Inativo",
    statusTextInitial: "Inicial",
    noServiceUsersFoundMessage: "Nenhum usuário de serviço encontrado.",
    rolesDescriptionPopoverAltText: "Passe o mouse para descrição das funções",
  },
};

export const serviceUsersListEs = {
  [pageNameKey]: {
    nameLabel: "Nombre para mostrar",
    usernameLabel: "Nombre de usuario",
    rolesLabel: "Roles",
    statusLabel: "Estado",
    expirationDateLabel: "Fecha de vencimiento",
    createdAtLabel: "Creado el",
    updatedAtLabel: "Última modificación",
    statusTextActive: "Activo",
    statusTextInactive: "Inactivo",
    statusTextInitial: "Inicial",
    noServiceUsersFoundMessage: "No se encontraron usuarios de servicio.",
    rolesDescriptionPopoverAltText:
      "Pasa el cursor para ver la descripción de roles",
  },
};

export const serviceUsersListDe = {
  [pageNameKey]: {
    nameLabel: "Anzeigename",
    usernameLabel: "Benutzername",
    rolesLabel: "Rollen",
    statusLabel: "Status",
    expirationDateLabel: "Ablaufdatum",
    createdAtLabel: "Erstellt am",
    updatedAtLabel: "Zuletzt geändert",
    statusTextActive: "Aktiv",
    statusTextInactive: "Inaktiv",
    statusTextInitial: "Initial",
    noServiceUsersFoundMessage: "Es wurden keine Service-Benutzer gefunden.",
    rolesDescriptionPopoverAltText: "Für Rollendetails hovern",
  },
};

export const serviceUsersListZhHans = {
  [pageNameKey]: {
    nameLabel: "显示名称",
    usernameLabel: "用户名",
    rolesLabel: "角色",
    statusLabel: "状态",
    expirationDateLabel: "到期日",
    createdAtLabel: "创建于",
    updatedAtLabel: "最后修改",
    statusTextActive: "活跃",
    statusTextInactive: "非活跃",
    statusTextInitial: "初始",
    noServiceUsersFoundMessage: "未找到服务用户。",
    rolesDescriptionPopoverAltText: "将鼠标悬停以查看角色描述",
  },
};

export const serviceUsersListIt = {
  [pageNameKey]: {
    nameLabel: "Nome visualizzato",
    usernameLabel: "Nome utente",
    rolesLabel: "Ruoli",
    statusLabel: "Stato",
    expirationDateLabel: "Data di scadenza",
    createdAtLabel: "Creato il",
    updatedAtLabel: "Ultima modifica",
    statusTextActive: "Attivo",
    statusTextInactive: "Inattivo",
    statusTextInitial: "Iniziale",
    noServiceUsersFoundMessage: "Nessun utente di servizio trovato.",
    rolesDescriptionPopoverAltText:
      "Posiziona qui il cursore per la descrizione dei ruoli",
  },
};

export const serviceUsersListNl = {
  [pageNameKey]: {
    createdAtLabel: "Aangemaakt op",
    expirationDateLabel: "Vervaldatum",
    nameLabel: "Weergavenaam",
    noServiceUsersFoundMessage: "Er zijn geen servicegebruikers gevonden.",
    rolesDescriptionPopoverAltText: "Beweeg de muis over voor rolbeschrijving",
    rolesLabel: "Rollen",
    statusLabel: "Status",
    statusTextActive: "Actief",
    statusTextInactive: "Inactief",
    statusTextInitial: "Initiële status",
    updatedAtLabel: "Laatst gewijzigd op",
    usernameLabel: "Gebruikersnaam",
  },
};

export const serviceUsersListTr = {
  [pageNameKey]: {
    createdAtLabel: "Oluşturulma Tarihi",
    expirationDateLabel: "Son kullanma tarihi",
    nameLabel: "Ekran adı",
    noServiceUsersFoundMessage: "Hiçbir hizmet kullanıcısı bulunamadı.",
    rolesDescriptionPopoverAltText:
      "Rollerin açıklaması için fareyle üzerine gelin",
    rolesLabel: "Roller",
    statusLabel: "Durum",
    statusTextActive: "Aktif",
    statusTextInactive: "Etkin değil",
    statusTextInitial: "İlk",
    updatedAtLabel: "Son Değiştirilme",
    usernameLabel: "Kullanıcı adı",
  },
};
